import { FC, Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppStateProvider } from "../components/AppStateProvider/AppStateProvider";
import { SentryProvider } from "../components/SentryProvider/SentryProvider";
import { ToasterProvider } from "../components/ToasterProvider/ToasterProvider";
import { PhoneNumberProvider } from "../components/PhoneNumberProvider/PhoneNumberProvider";
import { BookingProvider } from "../components/BookingProvider/BookingProvider";
import { PrivateRoute } from "../components/PrivateRoute/PrivateRoute";
import { RouteContainer } from "../components/RouteContainer/RouteContainer";
import { LoadingSpinner } from "../components/LoadingSpinner";

const ConferenceProvider = lazy(() => import("../components/ConferenceProvider/ConferenceProvider").then(module => ({ default: module.ConferenceProvider })));
const LoginPage = lazy(() => import("../components/LoginPage/LoginPage").then(module => ({ default: module.LoginPage })));
const ConferenceContainer = lazy(() => import("../components/ConferenceContainer/ConferenceContainer").then(module => ({ default: module.ConferenceContainer })));
const ConferenceEndedPage = lazy(() => import("../components/ConferenceEndedPage/ConferenceEndedPage").then(module => ({ default: module.ConferenceEndedPage })));
const NoAccessPage = lazy(() => import("../components/NoAccessPage/NoAccessPage").then(module => ({ default: module.NoAccessPage })));

export const Router: FC = () => {
	return (
		<BrowserRouter basename="/">
			<AppStateProvider>
				<SentryProvider>
					<ToasterProvider>
						<BookingProvider>
							<PhoneNumberProvider>
								<Suspense fallback={<LoadingSpinner />}>
									<Routes>
										<Route path="/" element={<RouteContainer />}>
											<Route index element={<LoginPage />} />
											<Route path="conference" element={
												<PrivateRoute>
													<ConferenceProvider>
														<ConferenceContainer />
													</ConferenceProvider>
												</PrivateRoute>
											} />
											<Route path="join/:participantId" element={<LoginPage />} />
											<Route path="enter/:bookingId" element={<LoginPage />} />
											<Route path="host/:bookingId/:conferenceId" element={<LoginPage />} />
											<Route path="ended" element={<ConferenceEndedPage />} />
											<Route path="no-access" element={<NoAccessPage />} />
											<Route path="*" element={<Navigate to={"/"} />} />
										</Route>
									</Routes>
								</Suspense>
							</PhoneNumberProvider>
						</BookingProvider>
					</ToasterProvider>
				</SentryProvider>
			</AppStateProvider>
		</BrowserRouter>
	);
};